import React, { Component } from "react";
import axios from 'axios';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { withStyles } from "@material-ui/core/styles";
import CommentsComponent from '../Comments'

const useStyles = theme => ({
  menu:{
      fontSize:'0.75rem',
  }
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Comments extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {comments:[], comment:'', loading: true}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.work_order_id
    	this.getComments(work_order_id)
    }


    getComments = async (id) => {
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.work_order().comments(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var comments = res.data[0].comments
	      		this.setState({comments: comments, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleChange = (comment) => {
    	this.setState({comment: comment})
    }


    handleSubmit = () => {
	    var formData = new FormData();
	    var url = api.work_order().comment(this.props.work_order_id);
	    formData.set('comment', this.state.comment)
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'Comentario cargado con éxito', 
		  			severity:'success'})

	      })
	      .catch(function (error) {
	      		var error_message = 'Ha ocurrido un error al cargar el comentario'
		  		self.setState({
		  			openSuccess: true,
		  			success_message: error_message, 
		  			severity:'warning'})
	    })

    }

  	handleCloseSuccess = () => {
  		this.setState({openSuccess: false, success_message:'', loading: true})
  		this.getComments(this.props.work_order_id)
  	}

	render() {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<Snackbar open={this.state.openSuccess} autoHideDuration={10000} onClose={this.handleCloseSuccess}>
					<Alert onClose={this.handleCloseSuccess} severity={this.state.severity}>
					  {this.state.success_message}
					</Alert>
				</Snackbar>
				{(!this.state.loading)
					?
						<CommentsComponent comments={this.state.comments} onChange={this.handleChange} onSubmit={this.handleSubmit} />
					:
						''
				}
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(Comments);

